// extracted by mini-css-extract-plugin
export default {"loveToDo":"LoveToDo_loveToDo__m7X5E","loveToDo__heading":"LoveToDo_loveToDo__heading__dPsUY","loveToDo__details":"LoveToDo_loveToDo__details__NIVRF"};